import { ProjectTask } from '@/types';

interface GanttTask {
    id: string;
    text: string;
    start_date: string;
    end_date: string;
    duration: number;
    progress: number;
    status: string;
    type: string;
    assigned_to?: string | null;
    department_key?: string | null;
    department_label?: string | null;
    is_project_timeline?: boolean;
    parent?: string;
}

interface GanttLink {
    id: number;
    source: string;
    target: string;
    type: string;
}

export function transformTasksToGantt(tasks: ProjectTask[], projectTimelineLabel = 'Project timeline'): { tasks: GanttTask[]; links: GanttLink[] } {
    const ganttTasks: GanttTask[] = tasks.map((task) => ({
        id: task.id,
        text: task.is_project_timeline ? projectTimelineLabel : task.name,
        start_date: task.start_date,
        end_date: task.end_date,
        duration: task.duration_days,
        progress: 0,
        status: task.status,
        type: task.type,
        assigned_to: task.assignee ? `${task.assignee.first_name} ${task.assignee.last_name}` : null,
        department_key: task.department_key ?? null,
        department_label: null,
        is_project_timeline: Boolean(task.is_project_timeline),
        parent: task.parent_task_id || undefined,
    }));

    const links: GanttLink[] = [];
    let nextLinkId = 1;

    tasks.forEach((task) => {
        if (!task.dependencies) {
            return;
        }
        try {
            const dependencies = Array.isArray(task.dependencies) ? task.dependencies : JSON.parse(task.dependencies as string);
            dependencies.forEach((depId: string) => {
                const sourceId = String(depId).trim();
                if (!sourceId) {
                    return;
                }
                links.push({
                    id: nextLinkId++,
                    source: sourceId,
                    target: task.id,
                    type: '0',
                });
            });
        } catch (e) {
            console.error('Error parsing task dependencies:', e);
        }
    });

    return { tasks: ganttTasks, links };
}
